import ActionButton from 'components/ActionButton';
import AddNoteModal from 'components/AddNoteModal';
import DeleteAction from 'components/DeleteAction';
import EditAction from 'components/EditAction';
import React, { useState } from 'react';
import { deleteNote } from 'services';
import { DATE_FORMATS, formatDate, showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const SubscriptionNotes = props => {
  const [noteToEdit, setNoteToEdit] = useState<Record<string, any> | null>(null);
  const [noteModalOpen, setNoteModalOpen] = useState<boolean>(false);
  const [deleteLoading, setDeleteLoading] = useState<string>('');
  const { subscriptionId, notes, refetchData } = props;

  const deleteNoteFn = async (noteId: string) => {
    setDeleteLoading(noteId);
    const data = {
      id: subscriptionId,
      noteId,
    };
    try {
      await deleteNote(data);
      showSuccess(`Note deleted successfully`);
      refetchData();
    } catch (e) {
      showError(e);
    } finally {
      setDeleteLoading('');
    }
  };

  const getEmptyNotesMessage = () => (
    <div className={styles['empty-notes-message']}>No Notes added</div>
  );

  const getNotes = () => notes.map((note, i) => (
    <div key={i} className={styles['single-note']}>
      <div className={styles['note-details']}>
        <div className={styles['note-message']}>{note.note}</div>
        <div className={styles['note-meta']}>
          {note.by?.full_name ? (
            <span className={styles['note-created-by']}>{note.by.full_name}</span>
          ) : null}
          <span className={styles['note-created-at']}>{formatDate(note.createdAt, DATE_FORMATS.MM_DD_YYYY_hh_mm_A)}</span>
        </div>
      </div>
      <div className={styles['notes-action']}>
        <EditAction
          loading={false}
          onClick={() => {
            setNoteToEdit(note);
            setNoteModalOpen(true);
          }}
        />
        <DeleteAction
          loading={deleteLoading === note.id}
          onClick={() => deleteNoteFn(note.id)}
        />
      </div>
    </div>
  ));

  return (
    <div>
      {noteModalOpen && (
        <AddNoteModal
          onSuccess={refetchData}
          noteToEdit={noteToEdit}
          toggleModal={() => {
            setNoteToEdit(null);
            setNoteModalOpen(!noteModalOpen);
          }}
          subscriptionId={subscriptionId}
        />
      )}
      <div className={styles['notes-section']}>
        <div className={styles['section-header']}>
          <div className={styles['subheading']}>Notes</div>
          <ActionButton
            active={true}
            isLoading={false}
            onClick={() => setNoteModalOpen(true)}
            text={<>Note <span>+</span></>}
          />
        </div>
        {notes?.length ? getNotes() : getEmptyNotesMessage()}
      </div>
    </div>
  );
};

export default SubscriptionNotes;